import { Maybe } from '@/types';

export const blogListContainerStyles = (displayType: string) => ({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	paddingX: { xs: '1.25rem', md: '2%', lg: '5%', xl: '6rem' },
	paddingY: { xs: '1.25rem', md: '1rem', lg: '1.75rem' },
	paddingLeft: displayType === 'One Row' && { xs: 0 },
});

export const blogListTitlerContainerStyles = {
	paddingX: { xs: '1.25rem', md: '2%', lg: '5%', xl: '6rem' },
};

const getGridCount = (defaultCount: number, newCount?: Maybe<number>) => {
	const count = newCount ?? defaultCount;
	return `repeat(${count}, 1fr)`;
};

export const blogListHeaderStyles = {
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	paddingTop: { xs: '1.25rem', md: '1rem', lg: '3.75rem' },
	paddingBottom: { xs: '0.5rem', md: '1rem', lg: '0.75rem' },
};

export const blogListTitleStyles = {
	fontSize: { xs: '14px', md: '14px' },
	fontWeight: 700,
	lineHeight: '16px',
	fontFamily: 'Messina Sans',
	letterSpacing: '3px',
};

export const getBlogListItemContainerStyles = (
	isSmallScreen: boolean,
	countAcrossDesktop?: Maybe<number>,
	countAcrossMobile?: Maybe<number>
) => ({
	display: isSmallScreen ? 'flex' : 'grid',
	gridTemplateColumns: {
		xs: getGridCount(2, countAcrossMobile),
		md: getGridCount(3, countAcrossDesktop),
		lg: getGridCount(4, countAcrossDesktop),
	},
	gridColumnGap: { xs: '.75rem', lg: '1.25rem' },
	gridRowGap: { xs: '1.75rem', lg: '2.5rem' },
	width: '100%',
});

export const showMoreBoxStyles = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	marginTop: '3rem',
	gap: '.75rem',
};

export const getPaginationStyles = {
	flexWrap: 'nowrap',
	'MuiPagination-ul css-wjh20t-MuiPagination-ul': {
		flexWrap: 'nowrap',
	},
	'.MuiPagination-ul .MuiPaginationItem-root': {
		fontSize: '0.8rem', // Smaller font size
		color: '#FFFFFF',
		padding: '0 .15rem',
		margin: '0 .5rem',
		width: { xs: '1.5rem', md: '2rem' }, // Set a fixed width and height for a perfect circle
		height: { xs: '1.5rem', md: '2rem' },
		minWidth: '0',
		alignItems: 'center',
		borderRadius: '50%',
		backgroundColor: '#696E72',
	},
	'.MuiPagination-ul .Mui-selected': {
		borderRadius: '50%',
		backgroundColor: '#289AE2',
		width: { xs: '1.5rem', md: '2rem' }, // Set a fixed width and height for a perfect circle
		height: { xs: '1.5rem', md: '2rem' },
	},
	// This targets the specific button that holds the "previous" and "next" icons
	'.MuiPaginationItem-root[aria-label="Go to next page"], .MuiPaginationItem-root[aria-label="Go to previous page"]':
		{
			color: '#289AE2', // Color of the arrow icon
			backgroundColor: 'transparent', // The key change to make the background disappear
			border: 'none', // The key change to make the border disappear

			'&:hover': {
				backgroundColor: 'transparent', // Ensure it remains transparent on hover
			},
		},
	// This targets the icon inside the button
	'.MuiPaginationItem-icon': {
		color: '#289AE2',
	},
	// This targets the ellipsis "..." items
	'.MuiPagination-ul .MuiPaginationItem-root.MuiPaginationItem-ellipsis': {
		// Explicitly set these properties to override the parent's
		backgroundColor: 'transparent',
		border: 'none',

		// Remove padding to make it a clean "..."
		padding: '0',
		margin: '0 .25rem',
		width: 'auto', // Let the width be determined by its content
		height: 'auto',
		minWidth: '0',
		color: '#FFFFFF',
	},
};
